import { SetDefaultData, FetchStreetTypeRequest, UpdateField, UpdateStreetTypeRequest } from './../street-types.actions';
import { getUpdateStreetTypeState } from '../street-types.selectors';
import Validator from '@shared/validatorjs/src/validator';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import FormTrait from 'src/app/traits/form.trait';
import { Subscription } from 'rxjs';
import { Map } from 'immutable';

@Component({
  selector: 'app-update-street-type',
  templateUrl: './update-street-type.component.html',
  styleUrls: ['./update-street-type.component.css']
})
export class UpdateStreetTypeComponent extends FormTrait implements OnInit {

  private state$: Subscription;
  public isLoading: boolean;
  public userId: number;

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get("id"))
    this.store.dispatch<any>(new SetDefaultData('updateStreetType'))
    this.state$ = this.store.pipe(select(getUpdateStreetTypeState)).subscribe(state => {
      this.state = state;
      this.isLoading = state.get('isLoading')
    });

    this.store.dispatch<any>(new FetchStreetTypeRequest(this.userId))
  }

  public handleFieldChange(e: any, name: null | string = null): void {

    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'updateStreetType.data')
    );

    this.store.dispatch(
      new UpdateField('validationErrors', this.state
        .get('validationErrors')
        .delete(name || e.target.name), 'updateStreetType')
    );
  }

  validation() {
    const data = this.state.get('data');
    const rules = {
      name: "required"
    };
    const validator = new Validator(
      {
        name: data.get('name')
      },
      rules,
    );

    return validator;
  }

  public onSubmit(e: Event): void {

    e.preventDefault();

    const validation = this.validation();
    const payload = this.state.get('data').toJS();

    if (validation.passes()) {
      this.store.dispatch(new UpdateStreetTypeRequest(this.userId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'updateStreetType')
      );
    }
  }

}
